__turbopack_context__.v({
  "AccessoryPage__Breadcrumbs": "CUNhtq_AccessoryPage__Breadcrumbs",
  "AccessoryPage__HeroWrapper": "CUNhtq_AccessoryPage__HeroWrapper",
});
